function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4H7v24h5V4zM7 2a2 2 0 00-2 2v24a2 2 0 002 2h5a2 2 0 002-2V4a2 2 0 00-2-2H7zM25 4h-5v24h5V4zm-5-2a2 2 0 00-2 2v24a2 2 0 002 2h5a2 2 0 002-2V4a2 2 0 00-2-2h-5z",
  fill: "currentColor"
})));